module.exports = __webpack_public_path__ + "img/icon-question-option-delete.9e77d762.svg";